import { generateHTML, JSONContent } from '@tiptap/core';
import { HTMLAttributes, useMemo } from 'react';
import { getExtensions } from './extensions';
import { useEditorStyles } from './useEditorStyles';
import { useTiptapFileSrcResolverFromContext } from './useTiptapFileSrc';

export function EditorHTML({
  content,
  ...props
}: { content: JSONContent } & Omit<
  HTMLAttributes<HTMLDivElement>,
  'content' | 'dangerouslySetInnerHTML' | 'className'
>) {
  useEditorStyles();
  const resolveFileSrc = useTiptapFileSrcResolverFromContext();
  const html = useMemo(
    () => generateHTML(content, getExtensions(resolveFileSrc)),
    [content, resolveFileSrc],
  );
  return (
    <div
      className={'duke-tiptap-editor tiptap'}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
}
